module.exports = "/_next/static/images/wom-e909c11a1e383d9069167ab4602f09f0.png";